import React from 'react';
import InputComponent from "../components/fields/InputComponent"
import country from '../assests/js/country.json'
import ReCAPTCHAA from './ReCAPTCHA';
import CheckboxComponent from '../components/fields/CheckboxComponent'
import { connect } from 'react-redux';

const CompanyDetails = React.memo((props) => {
// props.inputs.country = props.country
    const tracking = () => {
        if (!window['sasD360DataLayer']) {
            (window).sasD360DataLayer = [];
        }
        window['sasD360DataLayer'].push({
            event: 'interaction',
            'interaction.category': 'SAS For Business', 
            'interaction.action': 'Manual signup link click',
            'interaction.label': 'Tracking Manual signup link clicked'
        });
        window.location.href = "https://www.flysas.com/en/corporate-program/become-corporate-customer/";
    }
    return <>
        <div>
            

            <div className="innder-title-container">
                <div className="innder-title">{props.labels['corporate.signup.second.page.title']}</div>
            
            </div>
            {props.enableCompanyDetailsPage && !props.companyInofoMissing &&
                <><div className='form-row-responsive'>
                    <div className="sas-input  focused">
                        <label className="form-field" element="formField"> 
                            <select defaultValue={props.country.toUpperCase()} name='country' onChange={props.onchangeCountry}>
                                {props.listOfCounties.countries?.map(key => (
                                   (key.code == 'SE' || key.code == 'DK' || key.code == 'NO' ? <option  value={key.code.toUpperCase()}>{key.name}</option> : '')
                                ))}

                            </select>
                            <div className="label" element="label">{props.labels['corporate.signup.label.countryName']}</div>
                        </label>
                    </div>
                    
                    <InputComponent label={props.labels['corporate.signup.label.org.no']} name="org" invalid={props.errorMsg.org ? 'invalid' : ''} onFocusInput={props.onFocusInput} onBlurInput={props.onBlurInput} focused={props.focused.org ? 'focused' : ''} onChangeInput={props.onChangeInput} orgNumberValid={props.orgNumberLength} value={props.inputs.org} error={props.labels['corporate.signup.error.msg.for.org']} />

                </div>
               <div className='outside-country-link'><a onClick={() => tracking()}>{props.labels['corporate.signup.to.other.country.link']}</a></div>
                   
                    <ReCAPTCHAA invalid={props.errorMsg.captcha ? 'invalid' : ''} onChangeCaptch={props.onChangeCaptch} language={props.language} error={props.labels['corporate.signup.error.msg.for.captcha']} />
                

                </>
                }
               
            {props.enableCompanyInfo &&
                <><div>
                    <div className='company-detail-info'>

                        <div className='fields-details'>
                            <div className="field-name">{props.labels['corporate.signup.label.companyName']}:</div>
                            <div>{props.enableCompanyInfo.company[0].name}</div>
                        </div>
                        <div className='fields-details'>
                            <div className="field-name">{props.labels['corporate.signup.label.org.no']}:</div>
                            <div>{props.enableCompanyInfo.company[0].id}</div>
                        </div>
                        <div className='fields-details'>
                            <div className="field-name">{props.labels['corporate.signup.label.address']}:</div>
                            <div>{props.enableCompanyInfo.company[0].address}, {props.enableCompanyInfo.company[0].zipCode} {props.enableCompanyInfo.company[0].town}, {props.enableCompanyInfo.company[0].county}</div>
                        </div>
                    </div>
                    {/* <div className='terms'>
                        <CheckboxComponent invalid={props.errorMsg.termAndCondition ? 'invalid' : ''} value={props.inputs.termAndCondition} onClickFunction={props.onChangeInput} error={props.labels['corporate.signup.error.tems.and.condition']} label={props.labels['corporate.signup.accepted']} link="https://assets.ctfassets.net/oz9qk43ly6yk/qkXweVgz7XLCfc3imaWtI/31eee1f9f5729b0e097034669ba2ecab/sme-sas-for-business-en.pdf" linktext={props.labels['corporate.signup.terms.and.conidtion']} name="termAndCondition" id="termAndCondition" checked="checked" />
                    </div> */}
                </div>
                </>
            }
            {props.CompanyAllreadyConnected &&
                <><div>{props.labels['corporate.signup.already.connected.with.this.org.desc']} {props.states.org} {props.labels['corporate.signup.already.connected.with.this.org.desc.next.line']} </div></>
            }
            {props.orgNoInvalid &&
                <><div>{props.labels['corporate.signup.no.company.withs.is.org.no']} {props.states.org}. {props.labels['corporate.signup.no.company.withs.is.org.no.next.line']}</div></>
            }
            {props.companyInofoMissing && 
             <><div>We are unable to find your company details <a href='https://www.flysas.com/en/corporate-program/become-corporate-customer/'>please register here</a></div></>
            }
        </div>
    </>
});
const mapStateFromReducer = (state) => ({
    labels: state.corporateSignupReducer.labels || {},
    getSessionStorage: state.corporateSignupReducer.getSessionStorage || {}
})
export default connect(
    mapStateFromReducer,
    null
)(CompanyDetails);
